// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Select.module.scss  */
.Select-module-Root_3ZM {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  width: 100%;
  font-family: var(--control-font-family);
  vertical-align: top; }

.Select-module-FieldText_2bd.Select-module-hasHiddenIndicator_1A2 input {
  text-overflow: ellipsis; }

.Select-module-expanded_1aO {
  border-bottom-width: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0; }

.Select-module-focused_29r {
  border-color: var(--select-border-color-focus); }

.Select-module-Popup_3rc {
  z-index: 3;
  overflow-y: auto;
  max-height: 240px;
  padding: 0 0.25rem;
  border-style: solid;
  border-color: var(--select-border-color);
  border-top-width: 0;
  border-radius: 0 0 0.5rem 0.5rem; }
  .Select-module-Popup_3rc.Select-module-focused_29r {
    border-color: var(--select-border-color-focus); }
  .Select-module-Popup_3rc::-webkit-scrollbar {
    width: 6px;
    height: 6px; }
  .Select-module-Popup_3rc::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
    background-color: #ccc; }
  .Select-module-Popup_3rc[aria-hidden='false']::before {
    position: absolute;
    width: 97%;
    height: 1px;
    content: '';
    background-color: var(--select-border-color); }

.Select-module-NoOptions_V5r {
  padding: 0.5rem 0.75rem;
  color: #576875; }

.Select-module-Loading_nhi {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  color: #576875; }

.Select-module-IconExpandIndicator_2xV {
  margin-right: 4px;
  color: #9d9d9d; }

.Select-module-Tags_2kR {
  margin-top: 10px; }

.Select-module-hasError_1Kk .Select-module-FieldText_2bd,
.Select-module-hasError_1Kk .Select-module-Popup_3rc {
  border-color: var(--field-text-border-color-has-error); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Select/Select.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,uCAAuC;EACvC,mBAAmB,EAAE;;AAEvB;EACE,uBAAuB,EAAE;;AAE3B;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B,EAAE;;AAEhC;EACE,8CAA8C,EAAE;;AAElD;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,gCAAgC,EAAE;EAClC;IACE,8CAA8C,EAAE;EAClD;IACE,UAAU;IACV,WAAW,EAAE;EACf;IACE,qBAAqB;IACrB,sBAAsB,EAAE;EAC1B;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,4CAA4C,EAAE;;AAElD;EACE,uBAAuB;EACvB,cAAc,EAAE;;AAElB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc,EAAE;;AAElB;EACE,iBAAiB;EACjB,cAAc,EAAE;;AAElB;EACE,gBAAgB,EAAE;;AAEpB;;EAEE,sDAAsD,EAAE","sourcesContent":["/*  imported from Select.module.scss  */\n.Select-module-Root_3ZM {\n  position: relative;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  font-family: var(--control-font-family);\n  vertical-align: top; }\n\n.Select-module-FieldText_2bd.Select-module-hasHiddenIndicator_1A2 input {\n  text-overflow: ellipsis; }\n\n.Select-module-expanded_1aO {\n  border-bottom-width: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0; }\n\n.Select-module-focused_29r {\n  border-color: var(--select-border-color-focus); }\n\n.Select-module-Popup_3rc {\n  z-index: 3;\n  overflow-y: auto;\n  max-height: 240px;\n  padding: 0 0.25rem;\n  border-style: solid;\n  border-color: var(--select-border-color);\n  border-top-width: 0;\n  border-radius: 0 0 0.5rem 0.5rem; }\n  .Select-module-Popup_3rc.Select-module-focused_29r {\n    border-color: var(--select-border-color-focus); }\n  .Select-module-Popup_3rc::-webkit-scrollbar {\n    width: 6px;\n    height: 6px; }\n  .Select-module-Popup_3rc::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #ccc; }\n  .Select-module-Popup_3rc[aria-hidden='false']::before {\n    position: absolute;\n    width: 97%;\n    height: 1px;\n    content: '';\n    background-color: var(--select-border-color); }\n\n.Select-module-NoOptions_V5r {\n  padding: 0.5rem 0.75rem;\n  color: #576875; }\n\n.Select-module-Loading_nhi {\n  display: flex;\n  justify-content: center;\n  padding: 0.5rem 0.75rem;\n  color: #576875; }\n\n.Select-module-IconExpandIndicator_2xV {\n  margin-right: 4px;\n  color: #9d9d9d; }\n\n.Select-module-Tags_2kR {\n  margin-top: 10px; }\n\n.Select-module-hasError_1Kk .Select-module-FieldText_2bd,\n.Select-module-hasError_1Kk .Select-module-Popup_3rc {\n  border-color: var(--field-text-border-color-has-error); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
